// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GUzi","newExpiryDate":"styles_newExpiryDate__1PIRA","footer":"styles_footer__qGhYN"};